import {
  CREATE_TICKET,
  UPLOAD_ATTACHMENTS,
  DELETE_ATTACHMENT,
  UPDATE_REQUEST
} from "./types";
import * as supportApi from "@/api-client/zendesk";

export default {
  async createTicket({ commit }, { data, onSuccess, onError }) {
    commit({
      type: CREATE_TICKET.request
    });

    try {
      const createdTicket = await supportApi.createRequest({
        ...data
      });

      commit({
        type: CREATE_TICKET.success,
        payload: createdTicket
      });

      onSuccess ? onSuccess(createdTicket) : null;
      return createdTicket;
    } catch (e) {
      const err = e || {};

      commit({
        type: CREATE_TICKET.error,
        error: e
      });

      onError ? onError(err) : null;
    }
  },

  async updateRequest({ commit }, { data, onSuccess, onError }) {
    commit({
      type: UPDATE_REQUEST.request
    });

    const { request } = data;

    if (!request.id) {
      return;
    }

    try {
      const updatedRequest = await supportApi.updateRequest(request.id, data);

      commit({
        type: UPDATE_REQUEST.success,
        payload: updatedRequest
      });
    } catch (e) {
      const err = e || {};

      commit({
        type: UPDATE_REQUEST.error,
        error: e
      });

      onError ? onError(err) : null;
    }
  },

  async uploadAttachments({ commit }, { data, onSuccess, onError }) {
    commit({
      type: UPLOAD_ATTACHMENTS.request
    });

    try {
      const uploadedAttachmentsTokens = await supportApi.uploadAttachments(
        data
      );

      commit({
        type: UPLOAD_ATTACHMENTS.success,
        payload: uploadedAttachmentsTokens
      });

      onSuccess ? onSuccess(uploadedAttachmentsTokens) : null;
      return uploadedAttachmentsTokens;
    } catch (e) {
      const err = e || {};

      commit({
        type: UPLOAD_ATTACHMENTS.error,
        error: e.message
      });

      onError ? onError(err) : null;
    }
  },

  async deleteAttachment({ commit }, { data, onSuccess, onError }) {
    commit({
      type: DELETE_ATTACHMENT.request
    });

    try {
      const response = await supportApi.deleteAttachment(data);

      commit({
        type: DELETE_ATTACHMENT.success,
        payload: response
      });

      //api doesn't return anything after succsessfull deliting
      //so action return just token from args
      onSuccess ? onSuccess(data) : null;
      return data;
    } catch (e) {
      const err = e || {};

      commit({
        type: DELETE_ATTACHMENT.error,
        error: e
      });

      onError ? onError(err) : null;
    }
  }
};
